const nl = {
  // ============================================================
  // COMMON — Gedeeld in de gehele applicatie
  // ============================================================
  common: {
    loading: 'Laden...',
    error: 'Fout',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    create: 'Aanmaken',
    add: 'Toevoegen',
    remove: 'Verwijderen',
    close: 'Sluiten',
    confirm: 'Bevestigen',
    apply: 'Toepassen',
    reset: 'Herstellen',
    search: 'Zoeken',
    filter: 'Filteren',
    clear: 'Wissen',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    submit: 'Indienen',
    update: 'Bijwerken',
    refresh: 'Vernieuwen',
    export: 'Exporteren',
    import: 'Importeren',
    download: 'Downloaden',
    upload: 'Uploaden',
    print: 'Afdrukken',
    copy: 'Kopiëren',
    yes: 'Ja',
    no: 'Nee',
    ok: 'OK',
    done: 'Gereed',
    select: 'Selecteren',
    selectAll: 'Alles Selecteren',
    deselectAll: 'Alles Deselecteren',
    noResults: 'Geen resultaten gevonden',
    noData: 'Geen gegevens beschikbaar',
    required: 'Verplicht',
    optional: 'Optioneel',
    actions: 'Acties',
    details: 'Details',
    overview: 'Overzicht',
    summary: 'Samenvatting',
    total: 'Totaal',
    all: 'Alle',
    none: 'Geen',
    name: 'Naam',
    type: 'Type',
    status: 'Status',
    date: 'Datum',
    time: 'Tijd',
    description: 'Beschrijving',
    notes: 'Notities',
    comments: 'Opmerkingen',
    category: 'Categorie',
    priority: 'Prioriteit',
    nation: 'Natie',
    country: 'Land',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    location: 'Locatie',
    coordinates: 'Coördinaten',
    latitude: 'Breedtegraad',
    longitude: 'Lengtegraad',
    from: 'Van',
    to: 'Naar',
    createdAt: 'Aangemaakt',
    updatedAt: 'Bijgewerkt',
    createdBy: 'Aangemaakt door',
    modifiedBy: 'Gewijzigd door',
    active: 'Actief',
    inactive: 'Inactief',
    enabled: 'Ingeschakeld',
    disabled: 'Uitgeschakeld',
    showing: 'Weergave',
    of: 'van',
    page: 'Pagina',
    perPage: 'per pagina',
    rows: 'rijen',
    items: 'items',
    results: 'resultaten',
    sortBy: 'Sorteren op',
    ascending: 'Oplopend',
    descending: 'Aflopend',
    viewAll: 'Alles Bekijken',
    viewDetails: 'Details Bekijken',
    goBack: 'Terug',
    learnMore: 'Meer Informatie',
    seeMore: 'Meer Zien',
    showMore: 'Meer Tonen',
    showLess: 'Minder Tonen',
    expandAll: 'Alles Uitvouwen',
    collapseAll: 'Alles Invouwen',
    copied: 'Gekopieerd!',
    saved: 'Opgeslagen!',
    deleted: 'Verwijderd!',
    updated: 'Bijgewerkt!',
    created: 'Aangemaakt!',
    success: 'Geslaagd',
    warning: 'Waarschuwing',
    info: 'Informatie',
    danger: 'Gevaar',
    unknown: 'Onbekend',
    notAvailable: 'N.v.t.',
    never: 'Nooit',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    tomorrow: 'Morgen',
    now: 'Nu',
    ago: 'geleden',
    justNow: 'zojuist',
    minutesAgo: '{{count}}m geleden',
    hoursAgo: '{{count}}u geleden',
    daysAgo: '{{count}}d geleden',
    monthsAgo: '{{count}}mnd geleden',
    id: 'ID',
    version: 'Versie',
    language: 'Taal',
    theme: 'Thema',
    darkMode: 'Donkere Modus',
    lightMode: 'Lichte Modus',
    failedToLoad: 'Laden van gegevens mislukt',
    failedToSave: 'Opslaan mislukt',
    failedToDelete: 'Verwijderen mislukt',
    failedToUpdate: 'Bijwerken mislukt',
    confirmDelete: 'Weet u zeker dat u dit wilt verwijderen?',
    confirmAction: 'Weet u het zeker?',
    unsavedChanges: 'U hebt niet-opgeslagen wijzigingen. Weet u zeker dat u wilt vertrekken?',
    pageNotFound: '404 - Pagina Niet Gevonden',
    pageNotFoundDesc: 'De pagina die u zoekt bestaat niet.',
    backToDashboard: 'Terug naar Dashboard',
    characters: 'tekens',
    maxCharacters: 'Maximaal {{max}} tekens',
    remaining: '{{count}} resterend',
    selected: '{{count}} geselecteerd',
    of_total: '{{count}} van {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Koptekst, zijbalk, menu's
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Aanvragen',
    transports: 'Transporten',
    myPatients: 'Mijn Patiënten',
    statistics: 'Statistieken',
    flow: 'Stroom',
    resources: 'Resources',
    exercise: 'Oefening',
    administration: 'Administratie',
    map: 'Kaart',
    info: 'Informatie',
    users: 'Gebruikers',
    assets: 'Middelen',
    hubs: 'Hubs',
    treatmentFacilities: 'Behandelfaciliteiten',
    patientImport: 'Patiëntimport',
    assetTemplates: 'Middelensjablonen',
    dayTemplates: 'Dagsjablonen',
    announcementTicker: 'Aankondigingsbalk',
    exerciseStatistics: 'Oefenstatistieken',
    settings: 'Instellingen',
    auditLog: 'Auditlogboek',
    exerciseControl: 'Oefeningbeheer',
    dataSync: 'Gegevenssynchronisatie',
    documentation: 'Documentatie',
    support: 'Ondersteuning',
    about: 'Over',
    assetContracts: 'Asset Contracts',
    notifications: 'Meldingen',
    schedules: 'Schema\'s',
    capacityPlanning: 'Capaciteitsplanning',
    transportPlanning: 'Transportplanning',
    transportBooking: 'Transportboeking',
    flowDiagram: 'Stroomdiagram',
    changePassword: 'Wachtwoord Wijzigen',
    missions: 'Missies',
    startPoints: 'Startpunten',
    hospital: 'Ziekenhuis',
  },

  // ============================================================
  // AUTH — Inloggen, wachtwoord, sessie
  // ============================================================
  auth: {
    login: 'Inloggen',
    logout: 'Uitloggen',
    logoutNow: 'Nu Uitloggen',
    loggingIn: 'Bezig met inloggen...',
    loginFailed: 'Inloggen mislukt',
    email: 'E-mail',
    password: 'Wachtwoord',
    username: 'Gebruikersnaam',
    enterEmail: 'Voer uw e-mailadres in',
    enterPassword: 'Voer uw wachtwoord in',
    enterUsername: 'Voer uw gebruikersnaam in',
    forgotPassword: 'Wachtwoord vergeten?',
    forgotPasswordTitle: 'Wachtwoord Vergeten',
    forgotPasswordDesc: 'Voer uw gebruikersnaam en e-mailadres in. Als beide overeenkomen, worden de beheerders op de hoogte gesteld om uw wachtwoord te herstellen.',
    requestPasswordReset: 'Wachtwoordherstel Aanvragen',
    sending: 'Verzenden...',
    backToLogin: 'Terug naar Inloggen',
    pleaseWait: 'Wacht even voordat u het opnieuw probeert.',
    requestFailed: 'Aanvraag mislukt',
    credentialsMatch: 'Als de gegevens overeenkomen, zijn de beheerders op de hoogte gesteld.',
    forAccess: 'Neem voor toegang contact op met uw systeembeheerder.',
    changePassword: 'Wachtwoord Wijzigen',
    currentPassword: 'Huidig Wachtwoord',
    newPassword: 'Nieuw Wachtwoord',
    confirmPassword: 'Wachtwoord Bevestigen',
    passwordChanged: 'Wachtwoord succesvol gewijzigd',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 8 tekens bevatten',
    changingPassword: 'Wijzigen...',
    mustChangePassword: 'U moet uw wachtwoord wijzigen voordat u verder kunt gaan.',
    sessionExpiring: 'Sessie Verloopt',
    sessionExpireText: 'Uw sessie verloopt over <strong>{{time}}</strong>. Sla uw werk op en log opnieuw in om door te gaan.',
    dismiss: 'Sluiten',
    switchNation: 'Natie Wisselen',
    returnTo: 'Terug naar {{nation}}',
    viewingAs: 'U bekijkt als',
    loggedInAs: 'ingelogd als {{nation}}',
    trainingMode: 'UITSLUITEND VOOR TRAININGSDOELEINDEN',
    dedication: 'Gemaakt met liefde en toewijding aan het vak',
  },

  // ============================================================
  // ROLES — Gebruikersrollen en labels
  // ============================================================
  roles: {
    admin: 'Systeembeheerder',
    excon: 'Oefeningcontroleur',
    eu: 'EU-coördinator',
    planner: 'Planner',
    hub: 'Hubbeheerder',
    nation: 'Natie',
    readOnly: 'Alleen-lezen',
    systemAdmin: 'Systeembeheerder',
    transportPlanner: 'Transportplanner',
    systemRoles: 'Systeemrollen',
  },

  // ============================================================
  // STATUS — Aanvraag-, aanbod-, missiestatus
  // ============================================================
  status: {
    draft: 'Concept',
    underReview: 'In Beoordeling',
    published: 'Gepubliceerd',
    underSelection: 'In Selectie',
    accepted: 'Geaccepteerd',
    planned: 'Gepland',
    inTransit: 'Onderweg',
    completed: 'Voltooid',
    closed: 'Gesloten',
    withdrawn: 'Ingetrokken',
    pending: 'In Afwachting',
    rejected: 'Afgewezen',
    cancelled: 'Geannuleerd',
    active: 'Actief',
    inactive: 'Inactief',
    review: 'Beoordeling',
    selection: 'Selectie',
    transit: 'Onderweg',
  },

  // ============================================================
  // CATEGORIES — Aanvraagcategorieën
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personeel',
    material: 'Materiaal',
    equipment: 'Apparatuur',
    other: 'Overig',
    news: 'Nieuws',
  },

  // ============================================================
  // URGENCY — Urgentieniveaus
  // ============================================================
  urgency: {
    routine: 'Routine',
    priority: 'Prioriteit',
    urgent: 'Urgent',
    immediate: 'Onmiddellijk',
  },

  // ============================================================
  // ASSETS — Transportmiddeltypen
  // ============================================================
  assetTypes: {
    train: 'Trein',
    ship: 'Schip',
    aircraft: 'Vliegtuig',
    bus: 'Bus',
    ambulance: 'Ambulance',
    drone: 'Drone',
    helicopter: 'Helikopter',
    ferry: 'Veerboot',
    other: 'Overig',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Goedemorgen',
    goodAfternoon: 'Goedemiddag',
    goodEvening: 'Goedenavond',
    lastLogin: 'Laatste aanmelding',
    infrastructure: 'Infrastructuur',
    transportAssets: 'Transportmiddelen',
    treatmentFacilities: 'Behandelfaciliteiten',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Aanvraagstatistieken',
    viewAllRequests: 'Alle aanvragen bekijken',
    availableAssets: 'Beschikbare Middelen',
    seated: 'Zittend',
    lying: 'Liggend',
    intensive: 'Intensief',
    notifications: 'Meldingen',
    markAllRead: 'Alles als gelezen markeren',
    noNotifications: 'Nog geen meldingen',
    notifiedWhenActivity: 'U wordt op de hoogte gesteld wanneer er nieuwe activiteit is',
    viewDetailsBtn: 'Details Bekijken',
    nationUsers: 'Natiegebruikers',
    user: 'Gebruiker',
    roles: 'Rollen',
    noUsersFound: 'Geen gebruikers gevonden',
    participatingNations: 'Deelnemende Naties',
    exerciseDisclaimer: 'Dit systeem is uitsluitend bestemd voor oefeningen. Voer alleen gesimuleerde oefengegevens in. De werkprocessen zijn aangepast aan het oefenscenario en kunnen afwijken van de werkelijke procedures. De regels voor IT-beveiliging en gegevensbescherming blijven onverminderd van toepassing.',
    notConfigured: 'Niet geconfigureerd',
    requestCount: '{{count}} aanvra(a)g(en)',
    clickToView: 'Klik om te bekijken',
    systemAdministration: 'Systeembeheer',
    exerciseControlTitle: 'Oefeningbeheer',
    euCoordination: 'EU-coördinatie',
    transportPlanningTitle: 'Transportplanning',
    hubManagement: 'Hubbeheer',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nieuwe Aanvraag',
    myDrafts: 'Mijn Concepten',
    pendingReview: 'In Afwachting van Beoordeling',
    activeTransports: 'Actieve Transporten',
    myPatients: 'Mijn Patiënten',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Aanvragen',
    newRequest: 'Nieuwe Aanvraag',
    createRequest: 'Aanvraag Aanmaken',
    editRequest: 'Aanvraag Bewerken',
    requestDetail: 'Aanvraagdetail',
    requestId: 'Aanvraag-ID',
    fromNation: 'Van Natie',
    toNation: 'Naar Natie',
    requestingNation: 'Aanvragende Natie',
    receivingNation: 'Ontvangende Natie',
    category: 'Categorie',
    urgency: 'Urgentie',
    status: 'Status',
    patients: 'Patiënten',
    patientCount: 'Aantal Patiënten',
    offers: 'Aanbiedingen',
    offerCount: 'Aantal Aanbiedingen',
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    submittedBy: 'Ingediend door',
    reviewedBy: 'Beoordeeld door',
    description: 'Beschrijving',
    medicalDetails: 'Medische Details',
    transportDetails: 'Transportdetails',
    additionalInfo: 'Aanvullende Informatie',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Vertrekpunt',
    arrivalPoint: 'Aankomstpunt',
    estimatedDeparture: 'Geschat Vertrek',
    estimatedArrival: 'Geschatte Aankomst',
    submitForReview: 'Indienen ter Beoordeling',
    publish: 'Publiceren',
    startSelection: 'Selectie Starten',
    acceptOffer: 'Aanbieding Accepteren',
    markInTransit: 'Markeren als Onderweg',
    markCompleted: 'Markeren als Voltooid',
    closeRequest: 'Aanvraag Sluiten',
    withdrawRequest: 'Aanvraag Intrekken',
    withdraw: 'Intrekken',
    revertToDraft: 'Terug naar Concept',
    deleteRequest: 'Aanvraag Verwijderen',
    duplicateRequest: 'Aanvraag Dupliceren',
    createFollowUp: 'Geconsolideerde Aanvraag Aanmaken',
    followUpRequest: 'Geconsolideerde Aanvraag',
    parentRequest: 'Oorspronkelijke Aanvraag',
    childRequests: 'Geconsolideerde Aanvragen',
    noRequests: 'Geen aanvragen gevonden',
    noOffers: 'Nog geen aanbiedingen',
    addPatient: 'Patiënt Toevoegen',
    removePatient: 'Patiënt Verwijderen',
    patientDetails: 'Patiëntgegevens',
    contactPerson: 'Contactpersoon',
    contactPhone: 'Contacttelefoon',
    contactEmail: 'Contact-e-mail',
    specialRequirements: 'Speciale Vereisten',
    medicalEquipment: 'Medische Apparatuur',
    accompaniment: 'Begeleiding',
    timeline: 'Tijdlijn',
    history: 'Geschiedenis',
    addComment: 'Opmerking Toevoegen',
    writeComment: 'Schrijf een opmerking...',
    postComment: 'Opmerking Plaatsen',
    posting: 'Plaatsen...',
    noComments: 'Nog geen opmerkingen',
    coverageBar: 'Dekking',
    covered: 'gedekt',
    uncovered: 'ongedekt',
    filterByStatus: 'Filteren op status',
    filterByCategory: 'Filteren op categorie',
    filterByNation: 'Filteren op natie',
    searchRequests: 'Aanvragen zoeken...',
    confirmWithdraw: 'Weet u zeker dat u deze aanvraag wilt intrekken?',
    confirmDelete: 'Weet u zeker dat u deze aanvraag wilt verwijderen?',
    confirmPublish: 'Weet u zeker dat u deze aanvraag wilt publiceren? Deze wordt zichtbaar voor alle naties.',
    confirmStartSelection: 'Weet u zeker dat u de selectie wilt starten? Naties kunnen dan aanbiedingen doen.',
    warningStartSelection: 'Het starten van de selectie maakt deze aanvraag zichtbaar voor alle deelnemende naties. Zij kunnen dan aanbiedingen indienen voor de patiënten in deze aanvraag. Deze actie kan niet ongedaan worden gemaakt.',
    warningMakeOffer: 'Door deze aanbieding in te dienen, verbindt u uw natie tot het leveren van de voorgestelde hulp. Deze actie stelt de aanvragende natie en het oefeningbeheer op de hoogte.',
    saveDraft: 'Concept Opslaan',
    saving: 'Opslaan...',
    saveAndSubmit: 'Opslaan en Indienen',
    step: 'Stap {{number}}',
    generalInfo: 'Algemene Informatie',
    patientInfo: 'Patiëntinformatie',
    logisticsInfo: 'Logistieke Informatie',
    reviewSubmit: 'Beoordelen en Indienen',
    requestTitle: 'Aanvraagtitel',
    requestDescription: 'Aanvraagbeschrijving',
    numberOfPatients: 'Aantal Patiënten',
    typeOfAssistance: 'Type Hulpverlening',
    medicalTreatment: 'Medische Behandeling',
    transportAssistance: 'Transporthulp',
    both: 'Beide',
    treatmentOnly: 'Alleen Behandeling',
    transportOnly: 'Alleen Transport',
    validationErrors: 'Corrigeer de volgende fouten:',
    fieldRequired: 'Dit veld is verplicht',
    selectExitHub: 'Selecteer een uitgangshub',
    createExitHub: 'Uitgangshub Aanmaken',
    backToRequests: 'Terug naar Aanvragen',
    noRequestsFound: 'Geen aanvragen gevonden',
    createFirstRequest: 'Maak uw eerste aanvraag aan om te beginnen',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Aanbiedingen',
    createOffer: 'Aanbieding Aanmaken',
    makeOffer: 'Aanbieding Doen',
    manageOffers: 'Aanbiedingen Beheren',
    offerDetail: 'Aanbiedingdetail',
    offerId: 'Aanbieding-ID',
    offeringNation: 'Aanbiedende Natie',
    offerType: 'Type Aanbieding',
    treatment: 'Behandeling',
    transport: 'Transport',
    combined: 'Gecombineerd',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandelingsaanbod',
    transportOffer: 'Transportaanbod',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Patiënten Selecteren',
    selectedPatients: 'Geselecteerde Patiënten',
    patientSelection: 'Patiëntselectie',
    offerConfiguration: 'Aanbiedingconfiguratie',
    reviewOffer: 'Aanbieding Beoordelen',
    submitOffer: 'Aanbieding Indienen',
    submitting: 'Indienen...',
    acceptOffer: 'Aanbieding Accepteren',
    rejectOffer: 'Aanbieding Afwijzen',
    withdrawOffer: 'Aanbieding Intrekken',
    noOffers: 'Geen aanbiedingen beschikbaar',
    noOffer: 'No Offer',
    offerStatus: 'Aanbiedingsstatus',
    offerDate: 'Aanbiedingsdatum',
    transportAsset: 'Transportmiddel',
    departureDate: 'Vertrekdatum',
    arrivalDate: 'Aankomstdatum',
    treatmentFacility: 'Behandelfaciliteit',
    capacity: 'Capaciteit',
    availableCapacity: 'Beschikbare Capaciteit',
    totalCapacity: 'Totale Capaciteit',
    selectAsset: 'Middel Selecteren',
    selectFacility: 'Faciliteit Selecteren',
    offerNotes: 'Opmerkingen bij Aanbieding',
    confirmAccept: 'Weet u zeker dat u deze aanbieding wilt accepteren?',
    confirmReject: 'Weet u zeker dat u deze aanbieding wilt afwijzen?',
    extendTransport: 'Transport Verlengen',
    transportExtension: 'Transportverlenging',
    comparisonView: 'Vergelijkingsweergave',
    shortlist: 'Shortlist',
    addToShortlist: 'Aan Shortlist Toevoegen',
    removeFromShortlist: 'Van Shortlist Verwijderen',
    leaveConfirmTitle: 'Deze pagina verlaten?',
    leaveConfirmMessage: 'U hebt niet-opgeslagen wijzigingen. Weet u zeker dat u wilt vertrekken?',
    stayOnPage: 'Op Pagina Blijven',
    leavePage: 'Pagina Verlaten',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporten',
    missionDetail: 'Transportdetail',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Transport Aanmaken',
    overview: 'Overzicht',
    patientsTab: 'Patiënten',
    transportsTab: 'Transportetappes',
    treatmentTab: 'Behandeling',
    reviewTab: 'Beoordeling',
    departure: 'Vertrek',
    arrival: 'Aankomst',
    origin: 'Herkomst',
    destination: 'Bestemming',
    stops: 'Haltes',
    addStop: 'Halte Toevoegen',
    removeStop: 'Halte Verwijderen',
    stopName: 'Haltenaam',
    stopType: 'Haltetype',
    estimatedTime: 'Geschatte Tijd',
    actualTime: 'Werkelijke Tijd',
    asset: 'Middel',
    driver: 'Bestuurder',
    crew: 'Bemanning',
    noMissions: 'Geen transporten gevonden',
    completeMission: 'Transport Voltooien',
    cancelMission: 'Transport Annuleren',
    startTransport: 'Transport Starten',
    missionChain: 'Transportketen',
    linkedMissions: 'Gekoppelde Transporten',
    handover: 'Overdracht',
    handoverPoint: 'Overdrachtspunt',
    pickupPoint: 'Ophaalpunt',
    dropoffPoint: 'Afleverpunt',
    searchTransports: 'Transporten zoeken...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patiënten',
    myPatients: 'Mijn Patiënten',
    patientId: 'Patiënt-ID',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    dateOfBirth: 'Geboortedatum',
    age: 'Leeftijd',
    gender: 'Geslacht',
    male: 'Man',
    female: 'Vrouw',
    other: 'Overig',
    nationality: 'Nationaliteit',
    diagnosis: 'Diagnose',
    condition: 'Toestand',
    stable: 'Stabiel',
    critical: 'Kritiek',
    serious: 'Ernstig',
    treatmentNeeded: 'Behandeling Vereist',
    allergies: 'Allergieën',
    medications: 'Medicatie',
    bloodType: 'Bloedgroep',
    weight: 'Gewicht (kg)',
    infectious: 'Besmettelijk',
    mentalHealth: 'Geestelijke Gezondheid',
    mobility: 'Mobiliteit',
    ambulatory: 'Ambulant',
    wheelchair: 'Rolstoel',
    stretcher: 'Brancard',
    intensive: 'Intensieve Zorg',
    oxygenRequired: 'Zuurstof Vereist',
    ventilator: 'Beademing',
    medicalEscort: 'Medische Begeleiding',
    noPatients: 'Geen patiënten gevonden',
    patientDetails: 'Patiëntgegevens',
    medicalHistory: 'Medische Voorgeschiedenis',
    travelDocuments: 'Reisdocumenten',
    passport: 'Paspoort',
    pseudonymizedId: 'Gepseudonimiseerd ID',
    sensitiveData: 'Gevoelige Gegevens',
    journey: 'Patiënttraject',
    assignedTo: 'Toegewezen aan',
    currentLocation: 'Huidige Locatie',
    importPatients: 'Patiënten Importeren',
    exportPatients: 'Patiënten Exporteren',
    seated: 'Zittend',
    lying: 'Liggend',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Gebruikers',
    createUser: 'Gebruiker Aanmaken',
    editUser: 'Gebruiker Bewerken',
    deleteUser: 'Gebruiker Verwijderen',
    username: 'Gebruikersnaam',
    displayName: 'Weergavenaam',
    email: 'E-mail',
    password: 'Wachtwoord',
    role: 'Rol',
    roles: 'Rollen',
    nation: 'Natie',
    active: 'Actief',
    lastLogin: 'Laatste Aanmelding',
    createdAt: 'Aangemaakt',
    isNation: 'Natie',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planner',
    isHub: 'Hub',
    isReadOnly: 'Alleen-lezen',
    noUsers: 'Geen gebruikers gevonden',
    confirmDelete: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
    resetPassword: 'Wachtwoord Herstellen',
    generatePassword: 'Wachtwoord Genereren',
    searchUsers: 'Gebruikers zoeken...',
    userCreated: 'Gebruiker succesvol aangemaakt',
    userUpdated: 'Gebruiker succesvol bijgewerkt',
    userDeleted: 'Gebruiker succesvol verwijderd',
    selectNation: 'Selecteer een natie',
    mustChangePassword: 'Moet wachtwoord wijzigen bij volgende aanmelding',
    flagImage: 'Vlagafbeelding',
    exportUsers: 'Gebruikers Exporteren',
    importUsers: 'Gebruikers Importeren',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Middelen',
    createAsset: 'Middel Aanmaken',
    editAsset: 'Middel Bewerken',
    deleteAsset: 'Middel Verwijderen',
    assetName: 'Middelnaam',
    assetType: 'Middeltype',
    capacitySeated: 'Capaciteit (Zittend)',
    capacityLying: 'Capaciteit (Liggend)',
    capacityIntensive: 'Capaciteit (Intensief)',
    owner: 'Eigenaar',
    operator: 'Exploitant',
    baseLocation: 'Basislocatie',
    range: 'Bereik',
    speed: 'Snelheid',
    noAssets: 'Geen middelen gevonden',
    confirmDelete: 'Weet u zeker dat u dit middel wilt verwijderen?',
    searchAssets: 'Middelen zoeken...',
    assetCreated: 'Middel succesvol aangemaakt',
    assetUpdated: 'Middel succesvol bijgewerkt',
    assetDeleted: 'Middel succesvol verwijderd',
    exportAssets: 'Middelen Exporteren',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Startpunten',
    createHub: 'Hub Aanmaken',
    editHub: 'Hub Bewerken',
    deleteHub: 'Hub Verwijderen',
    hubName: 'Hubnaam',
    hubType: 'Hubtype',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ingangshub',
    airport: 'Luchthaven',
    seaport: 'Zeehaven',
    railStation: 'Treinstation',
    roadPoint: 'Wegpunt',
    ucpmClassification: 'UCPM-classificatie',
    icaoCode: 'ICAO-code',
    iataCode: 'IATA-code',
    noHubs: 'Geen hubs gevonden',
    confirmDelete: 'Weet u zeker dat u deze hub wilt verwijderen?',
    searchHubs: 'Hubs zoeken...',
    nationAssignment: 'Natietoewijzing',
    assignNations: 'Naties Toewijzen',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Behandelfaciliteiten',
    createFacility: 'Faciliteit Aanmaken',
    editFacility: 'Faciliteit Bewerken',
    deleteFacility: 'Faciliteit Verwijderen',
    facilityName: 'Faciliteitsnaam',
    facilityType: 'Faciliteitstype',
    hospitalName: 'Ziekenhuisnaam',
    bedCapacity: 'Bedcapaciteit',
    specialties: 'Specialismen',
    availableBeds: 'Beschikbare Bedden',
    totalBeds: 'Totaal Bedden',
    contactPerson: 'Contactpersoon',
    noFacilities: 'Geen behandelfaciliteiten gevonden',
    confirmDelete: 'Weet u zeker dat u deze faciliteit wilt verwijderen?',
    searchFacilities: 'Faciliteiten zoeken...',
    hubNationAssignment: 'Hub-natietoewijzing',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Schema\'s',
    createSchedule: 'Schema Aanmaken',
    editSchedule: 'Schema Bewerken',
    deleteSchedule: 'Schema Verwijderen',
    scheduleName: 'Schemanaam',
    scheduleType: 'Schematype',
    recurring: 'Terugkerend',
    oneTime: 'Eenmalig',
    frequency: 'Frequentie',
    daily: 'Dagelijks',
    weekly: 'Wekelijks',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    departureTime: 'Vertrektijd',
    arrivalTime: 'Aankomsttijd',
    stops: 'Haltes',
    addStop: 'Halte Toevoegen',
    noSchedules: 'Geen schema\'s gevonden',
    bookings: 'Boekingen',
    timeline: 'Tijdlijn',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Meldingen',
    markAllRead: 'Alles als gelezen markeren',
    markAsRead: 'Als gelezen markeren',
    markAsUnread: 'Als ongelezen markeren',
    noNotifications: 'Geen meldingen',
    viewAll: 'Alle Meldingen Bekijken',
    settings: 'Meldingsinstellingen',
    emailNotifications: 'E-mailmeldingen',
    inAppNotifications: 'In-app-meldingen',
    notifyOn: 'Mij informeren over',
    requestCreated: 'Nieuwe Aanvraag',
    requestPublished: 'Aanvraag Gepubliceerd',
    requestClosed: 'Aanvraag Gesloten',
    requestCompleted: 'Aanvraag Voltooid',
    commentAdded: 'Nieuwe Opmerking',
    offerReceived: 'Aanbieding Ontvangen',
    offerAccepted: 'Aanbieding Geaccepteerd',
    statusChanged: 'Status Gewijzigd',
    selectionStarted: 'Selectie Gestart',
    missionCreated: 'Transport Aangemaakt',
    missionStatusUpdated: 'Transport Bijgewerkt',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportverlenging',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Instellingen',
    general: 'Algemeen',
    system: 'Systeem',
    email: 'E-mail',
    sync: 'Synchronisatie',
    security: 'Beveiliging',
    appearance: 'Weergave',
    systemName: 'Systeemnaam',
    systemEmail: 'Systeem-e-mail',
    maintenanceMode: 'Onderhoudsmodus',
    readOnlyMode: 'Alleen-lezenmodus',
    emailEnabled: 'E-mail Ingeschakeld',
    smtpHost: 'SMTP-server',
    smtpPort: 'SMTP-poort',
    smtpUser: 'SMTP-gebruiker',
    smtpPassword: 'SMTP-wachtwoord',
    senderEmail: 'Afzender-e-mail',
    senderName: 'Afzendernaam',
    testEmail: 'Test-e-mail Verzenden',
    syncEnabled: 'Synchronisatie Ingeschakeld',
    syncUrl: 'Synchronisatie-URL',
    syncApiKey: 'Synchronisatie-API-sleutel',
    settingsSaved: 'Instellingen succesvol opgeslagen',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesktitel',
    helpdeskEmail: 'Helpdesk-e-mail',
    helpdeskPhone: 'Helpdesktelefoon',
    helpdeskInfo: 'Helpdeskinformatie',
    realLifeSupport: 'Ondersteuning in de Praktijk',
    trainingMode: 'Trainingsmodus',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Auditlogboeken',
    action: 'Actie',
    user: 'Gebruiker',
    target: 'Doel',
    details: 'Details',
    timestamp: 'Tijdstempel',
    ipAddress: 'IP-adres',
    noLogs: 'Geen auditlogboeken gevonden',
    searchLogs: 'Logboeken zoeken...',
    filterByAction: 'Filteren op actie',
    filterByUser: 'Filteren op gebruiker',
    exportLogs: 'Logboeken Exporteren',
    exportCsv: 'CSV Exporteren',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Oefeningbeheer',
    currentDay: 'Huidige Dag',
    exerciseDay: 'Oefendag',
    nextDay: 'Volgende Dag',
    previousDay: 'Vorige Dag',
    resetExercise: 'Oefening Herstellen',
    startExercise: 'Oefening Starten',
    endExercise: 'Oefening Beëindigen',
    dayReset: 'Dagherstel',
    confirmReset: 'Weet u zeker dat u de oefendag wilt herstellen? Dit wist alle gegevens van de huidige dag.',
    resetInProgress: 'Herstel bezig...',
    maintenanceMode: 'Onderhoudsmodus',
    enableMaintenance: 'Onderhoud Inschakelen',
    disableMaintenance: 'Onderhoud Uitschakelen',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Gegevenssynchronisatie',
    syncStatus: 'Synchronisatiestatus',
    lastSync: 'Laatste Synchronisatie',
    pendingItems: 'Items in Afwachting',
    syncNow: 'Nu Synchroniseren',
    syncing: 'Synchroniseren...',
    syncSuccess: 'Synchronisatie succesvol voltooid',
    syncFailed: 'Synchronisatie mislukt',
    outbox: 'Postvak Uit',
    inbox: 'Postvak In',
    configuration: 'Configuratie',
    targetUrl: 'Doel-URL',
    apiKey: 'API-sleutel',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kaart',
    layers: 'Lagen',
    requests: 'Aanvragen',
    hubs: 'Hubs',
    facilities: 'Faciliteiten',
    routes: 'Routes',
    showAll: 'Alles Tonen',
    hideAll: 'Alles Verbergen',
    zoomIn: 'Inzoomen',
    zoomOut: 'Uitzoomen',
    resetView: 'Weergave Herstellen',
    satellite: 'Satelliet',
    terrain: 'Terrein',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kaarttegels worden lokaal geserveerd',
    tilesOnline: 'Kaarttegels worden geladen van online servers',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistieken',
    overview: 'Overzicht',
    requestsByStatus: 'Aanvragen per Status',
    requestsByCategory: 'Aanvragen per Categorie',
    requestsByNation: 'Aanvragen per Natie',
    offersByStatus: 'Aanbiedingen per Status',
    patientsByCondition: 'Patiënten per Toestand',
    transportsByStatus: 'Transporten per Status',
    timeline: 'Tijdlijn',
    totalRequests: 'Totaal Aanvragen',
    totalOffers: 'Totaal Aanbiedingen',
    totalPatients: 'Totaal Patiënten',
    totalTransports: 'Totaal Transporten',
    averageResponseTime: 'Gemiddelde Responstijd',
    completionRate: 'Voltooiingspercentage',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Oefenstatistieken',
    overview: 'Overzicht',
    byCategory: 'Per Categorie',
    byNation: 'Per Natie',
    byDay: 'Per Dag',
    totalPatientsMoved: 'Totaal Verplaatste Patiënten',
    totalRequestsProcessed: 'Totaal Verwerkte Aanvragen',
    averageProcessingTime: 'Gemiddelde Verwerkingstijd',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Stroomdiagram',
    sankey: 'Sankey',
    nodeGraph: 'Knooppuntgrafiek',
    refresh: 'Vernieuwen',
    noData: 'Geen stroomgegevens beschikbaar',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Over',
    version: 'Versie',
    systemInfo: 'Systeeminformatie',
    buildDate: 'Bouwdatum',
    environment: 'Omgeving',
    description: 'ARCOS — Geavanceerd Aanvraagcommunicatiesysteem',
    subtitle: 'Slachtofferhulp en Medische Operaties',
    whatIsArcos: 'Wat is ARCOS? – Uitleg voor deelnemers aan de oefening',
    arcosDesc1: 'ARCOS is een digitaal hulpmiddel dat in deze oefening wordt gebruikt om internationale communicatie, verzoeken en coördinatieprocessen tussen de deelnemende actoren te ondersteunen en te structureren.',
    arcosDesc2: 'ARCOS biedt een vereenvoudigde, op de oefening gerichte weergave van de basisprincipes achter deze systemen.',
    arcosUsedFor: 'Tijdens de oefening wordt ARCOS gebruikt om typische processen weer te geven zoals:',
    arcosUsedForItem1: 'indienen en beheren van bijstandsverzoeken,',
    arcosUsedForItem2: 'coördineren van en reageren op ondersteuningsaanbiedingen,',
    arcosUsedForItem3: 'volgen van status en voortgang van verzoeken,',
    arcosUsedForItem4: 'en weergave van vereenvoudigde transport- of evacuatieworkflows.',
    arcosDesc3: 'De workflows in ARCOS zijn opzettelijk vereenvoudigd en aangepast aan de specifieke trainingsdoelstellingen.',
    arcosDesc4: 'Het doel van ARCOS is niet om een perfect of volledig echt systeem te simuleren.',
    arcosDesc5: 'Als bepaalde elementen afwijken van echte procedures die u kent, is dit verwacht.',
    facilitatedBy: 'Gefaciliteerd door MMCC-E',
    dhcInitiative: 'De Digital Health Corner (DHC) is een gezamenlijk initiatief van:',
    dhcAuthor1: 'Sven Giegerich — Duitse Strijdkrachten',
    dhcAuthor2: 'Mohamad Haji — Belgische Defensie',
    dhcConviction: 'Geboren uit de overtuiging dat innovatie gedijt waar passie pragmatisme ontmoet.',
    dhcInspired: 'Geïnspireerd door MMCC-E zijn we begonnen met het creëren van eenvoudige maar effectieve oplossingen.',
    dhcLove: 'We doen dit omdat we van ons werk houden en geloven dat digitale ideeën de samenwerking in militaire gezondheidszorg kunnen hervormen.',
    dhcOpen: 'DHC is een open platform: vrij van hiërarchieën, open voor ideeën, gedreven door nieuwsgierigheid.',
    dhcClosing: 'Digital Health Corner – waar nieuwsgierigheid samenwerking ontmoet.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentatie',
    gettingStarted: 'Aan de Slag',
    userGuide: 'Gebruikershandleiding',
    faq: 'Veelgestelde Vragen',
    troubleshooting: 'Probleemoplossing',
    apiReference: 'API-referentie',
    downloadTemplate: 'Sjabloon Downloaden',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patiëntimport',
    uploadFile: 'Bestand Uploaden',
    selectFile: 'Bestand Selecteren',
    preview: 'Voorbeeld',
    importNow: 'Nu Importeren',
    importing: 'Importeren...',
    importSuccess: '{{count}} patiënten succesvol geïmporteerd',
    importFailed: 'Import mislukt',
    downloadTemplate: 'Sjabloon Downloaden',
    dragDrop: 'Sleep een bestand hierheen of klik om te selecteren',
    supportedFormats: 'Ondersteunde formaten: XLSX, XLS, CSV',
    rowsFound: '{{count}} rijen gevonden',
    validRows: '{{count}} geldige rijen',
    invalidRows: '{{count}} ongeldige rijen',
    duplicateRows: '{{count}} dubbele rijen',
    previewData: 'Gegevens Bekijken',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanning',
    planRoute: 'Route Plannen',
    routeBuilder: 'Routebouwer',
    addWaypoint: 'Tussenpunt Toevoegen',
    removeWaypoint: 'Tussenpunt Verwijderen',
    estimatedDuration: 'Geschatte Duur',
    distance: 'Afstand',
    selectVehicle: 'Voertuig Selecteren',
  },

  transportBooking: {
    title: 'Transportboeking',
    bookTransport: 'Transport Boeken',
    availableSlots: 'Beschikbare Plaatsen',
    bookingConfirmed: 'Boeking Bevestigd',
    cancelBooking: 'Boeking Annuleren',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Capaciteitsplanning',
    totalCapacity: 'Totale Capaciteit',
    usedCapacity: 'Gebruikte Capaciteit',
    availableCapacity: 'Beschikbare Capaciteit',
    utilizationRate: 'Bezettingsgraad',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Middelensjablonen',
    dayTemplates: 'Dagsjablonen',
    createTemplate: 'Sjabloon Aanmaken',
    editTemplate: 'Sjabloon Bewerken',
    deleteTemplate: 'Sjabloon Verwijderen',
    templateName: 'Sjabloonnaam',
    applyTemplate: 'Sjabloon Toepassen',
    noTemplates: 'Geen sjablonen gevonden',
    confirmDelete: 'Weet u zeker dat u dit sjabloon wilt verwijderen?',
    confirmApply: 'Weet u zeker dat u dit sjabloon wilt toepassen? Dit overschrijft bestaande gegevens.',
    exportTemplates: 'Sjablonen Exporteren',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Aankondigingsbalk',
    createAnnouncement: 'Aankondiging Aanmaken',
    editAnnouncement: 'Aankondiging Bewerken',
    deleteAnnouncement: 'Aankondiging Verwijderen',
    message: 'Bericht',
    startTime: 'Starttijd',
    endTime: 'Eindtijd',
    active: 'Actief',
    noAnnouncements: 'Geen aankondigingen',
    confirmDelete: 'Weet u zeker dat u deze aankondiging wilt verwijderen?',
  },

  // ============================================================
  // COMPONENTS — Herbruikbare componentteksten
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Zoeken...',
      noResults: 'Geen resultaten gevonden',
      showing: '{{from}} tot {{to}} van {{total}} weergeven',
      rowsPerPage: 'Rijen per pagina',
      previousPage: 'Vorige pagina',
      nextPage: 'Volgende pagina',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bevestigen',
      cancel: 'Annuleren',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Niet-opgeslagen Wijzigingen',
      message: 'U hebt niet-opgeslagen wijzigingen. Weet u zeker dat u deze pagina wilt verlaten?',
      stay: 'Op Pagina Blijven',
      leave: 'Pagina Verlaten',
    },
    // EmptyState
    emptyState: {
      noData: 'Geen gegevens beschikbaar',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Er is iets misgegaan',
      message: 'Er is een onverwachte fout opgetreden. Probeer de pagina te vernieuwen.',
      retry: 'Opnieuw Proberen',
    },
    // ExportButton
    exportButton: {
      export: 'Exporteren',
      exporting: 'Exporteren...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Afdrukken',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Concept',
      review: 'Beoordeling',
      published: 'Gepubliceerd',
      selection: 'Selectie',
      inTransit: 'Onderweg',
      completed: 'Voltooid',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online Instantie',
      message: 'Alleen-lezenmodus. Gegevens worden gesynchroniseerd vanaf de primaire server.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'U bekijkt als',
      loggedInAs: 'ingelogd als {{nation}}',
      returnTo: 'Terug naar {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Pagina\'s, aanvragen, transporten zoeken...',
      searching: 'Zoeken...',
      noResults: 'Geen resultaten voor "{{query}}"',
      navigate: 'Navigeren',
      select: 'Selecteren',
      close: 'Sluiten',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Aanvragen',
        transports: 'Transporten',
        map: 'Kaart',
        myPatients: 'Mijn Patiënten',
        flowDiagram: 'Stroomdiagram',
        statistics: 'Statistieken',
        assets: 'Middelen',
        startPoints: 'Startpunten / Hubs',
        treatmentFacilities: 'Behandelfaciliteiten',
        users: 'Gebruikers',
        settings: 'Instellingen',
        auditLogs: 'Auditlogboeken',
        exerciseControl: 'Oefeningbeheer',
        dataSync: 'Gegevenssynchronisatie',
        patientImport: 'Patiëntimport',
        notifications: 'Meldingen',
        documentation: 'Documentatie',
      },
      actions: {
        importPatientsJson: 'Patiënten importeren (JSON)',
        importPatientsExcel: 'Patiënten importeren (Excel)',
        importUsers: 'Gebruikers importeren (Excel)',
        importAssetTemplates: 'Asset-sjablonen importeren (Excel)',
        importDayTemplates: 'Dagsjabloon-items importeren (Excel)',
        exportRequests: 'Aanvragen exporteren (Excel)',
        exportPatients: 'Patiënten exporteren (Excel)',
        exportUsers: 'Gebruikers exporteren (Excel)',
        exportCredentials: 'Referenties exporteren (PDF)',
        exportAuditExcel: 'Auditlogboek exporteren (Excel)',
        exportAuditPdf: 'Auditlogboek exporteren (PDF)',
        pagePatientImport: 'Pagina patiëntenimport',
        pageRequestDetail: 'Pagina aanvraagdetails',
        pageUsers: 'Pagina gebruikersbeheer',
        pageAssetTemplates: 'Pagina asset-sjablonen',
        pageDayTemplates: 'Pagina dagsjablonen',
        pageRequests: 'Pagina aanvragenlijst',
        pageAuditLogs: 'Pagina auditlogboek',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sessie Verloopt',
      message: 'Uw sessie verloopt over <strong>{{time}}</strong>. Sla uw werk op en log opnieuw in om door te gaan.',
      dismiss: 'Sluiten',
      logoutNow: 'Nu Uitloggen',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Selecteer 4 tijdzones',
      configure: 'Tijdzones configureren',
      reset: 'Herstellen',
      apply: 'Toepassen',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Locatie Kiezen',
      latitude: 'Breedtegraad',
      longitude: 'Lengtegraad',
      clickToSelect: 'Klik op de kaart om een locatie te selecteren',
    },
    // Modal
    modal: {
      close: 'Sluiten',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Start',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systeemonderhoud',
    message: 'Het systeem wordt hersteld voor de volgende oefendag. Wacht tot het proces is voltooid.',
    autoRefresh: 'Deze pagina wordt automatisch vernieuwd wanneer het systeem weer beschikbaar is.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Minimaal 10 tekens',
    uppercase: '1 hoofdletter',
    lowercase: '1 kleine letter',
    digit: '1 cijfer',
    special: '1 speciaal teken',
  },
};

export default nl;
